export default __webpack_public_path__ + "static/media/Pin.da50bc60.svg";